(function () {
  var hideTimer;

  function flashCart() {
    var buttons = document.querySelectorAll('.cart-drawer-button, .dock__item[aria-controls="CartDrawer"]');
    if (!buttons.length) return;
    buttons.forEach(function (button) {
      button.classList.add('ff-cart-added');
    });
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      buttons.forEach(function (button) {
        button.classList.remove('ff-cart-added');
      });
    }, 2400);
  }

  function markAdded() {
    var atc = document.getElementById('ff-atc');
    if (atc && !atc.disabled) {
      var previous = atc.innerHTML;
      atc.classList.add('ff-atc-added');
      atc.textContent = 'Added';
      window.setTimeout(function () {
        atc.classList.remove('ff-atc-added');
        atc.innerHTML = previous;
      }, 2000);
    }

    var sticky = document.getElementById('ff-sticky-atc');
    if (sticky) {
      var stickyPrevious = sticky.textContent;
      sticky.textContent = 'Added';
      window.setTimeout(function () {
        sticky.textContent = stickyPrevious;
      }, 2000);
    }
  }

  document.addEventListener('ajaxProduct:added', function () {
    flashCart();
    markAdded();
  });
})();
